export const headCells = [
    {
      id: "sNo",
      numeric: false,
      disablePadding: true,
      label: "S.no",
    },
    {
      id: "patientName",
      numeric: false,
      disablePadding: false,
      label: "Patient Name",
    },
    {
      id: "test",
      numeric: false,
      disablePadding: false,
      label: "Test",
    },
    {
      id: "dateTime",
      numeric: false,
      disablePadding: false,
      label: "Prescribed Date & Time",
    },
    {
      id: "assignTask",
      numeric: false,
      disablePadding: false,
      label: "Assign Task",
    },
    {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
    },
  ];
  